'use strict';

var SendOneFileMultipleResults = require('./send-one-file-multiple-results');

module.exports = function (send, path) {
  var sendFile = SendOneFileMultipleResults(send, path);
  return function (file, options, callback) {
    sendFile(file, options, function (err, results) {
      if (err) {
        return callback(err);
      }

      callback(null, results[0]);
    });
  };
};